module.exports = __webpack_public_path__ + "fonts/DM_Sans-700-latin6.c15d94a.woff2";